module.exports = __webpack_public_path__ + "images/imagequick1.34f09004.png";